import React, { Fragment } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, Grid } from '@material-ui/core';

import { GQLPlatformSaleCatalogWithPlatformMerchantContract } from '@jewelutions/core-crm-server-api-client-domain';
import { Chip, JwlTable, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { userLanguage } from '../../../../core/AuthContext';

interface IProps {
  merchantContract: GQLPlatformSaleCatalogWithPlatformMerchantContract;
  onClose: (success: boolean) => void;
}

export const PlatformMerchantContractEditDialog: React.FC<IProps> = ({
  merchantContract,
  onClose
}: IProps) => {
  const [
    promotePlatformSaleCatalogToMerchantActiveContract,
    {}
  ] = GQLOperationBuilder.platformSaleCatalog.promotePlatformSaleCatalogToMerchantActiveContract();

  const {
    data: saleCatalogsData,
    loading: saleCatalogsLoading,
    error: saleCatalogsError,
    refetch: refetchSaleCatalogs
  } = GQLOperationBuilder.platformSaleCatalog.getPlatformSaleCatalogs(
    { includeOnlyActiveContracts: true },
    { fetchPolicy: 'network-only' }
  );

  if (saleCatalogsLoading) return <LoadingSpinner />;

  const getPlatformSaleCatalogsRows = () => {
    return GQLOperationBuilder.platformSaleCatalog
      .platformSaleCatalogArrayFromResponse(saleCatalogsData)
      .map(saleCatalog => {
        return {
          cells: [
            <Chip
              size="small"
              mr={1}
              mb={1}
              label={saleCatalog.name[userLanguage]}
              $active={merchantContract.platformSaleCatalog.id === saleCatalog.id}
            />,
            new Date(Date.parse(saleCatalog.updatedAt)).toLocaleString(),
            <Button
              variant={'contained'}
              disabled={merchantContract.platformSaleCatalog.id === saleCatalog.id}
              color={'primary'}
              onClick={() =>
                promotePlatformSaleCatalogToMerchantActiveContract({
                  variables: {
                    platformSaleCatalogId: saleCatalog.id,
                    merchantPartyId: merchantContract.platformMerchantContract!.merchantPartyId
                  }
                }).then(_res => {
                  onClose(true);
                })
              }
              style={{ marginLeft: '8px' }}
            >
              Promote
            </Button>
          ]
        };
      });
  };

  return (
    <Dialog open={true} aria-labelledby="edit-merchant-contract">
      <Fragment>
        <DialogTitle>
          Select new platform sale catalog for
          {merchantContract.platformMerchantContract!.merchantParty.name}
        </DialogTitle>
        <DialogContent>
          <Grid item style={{ marginTop: '8px' }}>
            <JwlTable
              columns={['Platform Sale Catalog Name ', 'Updated At', 'Select']}
              rows={getPlatformSaleCatalogsRows()}
            />
          </Grid>
          <Grid item style={{ marginTop: '8px' }}>
            <Button color="primary" onClick={() => onClose(false)}>
              Close
            </Button>
          </Grid>
        </DialogContent>
      </Fragment>
    </Dialog>
  );
};

export default PlatformMerchantContractEditDialog;
